import React, { useState } from 'react';
import { 
  BarChart3, 
  Users, 
  Settings, 
  LogOut,
  Home,
  Star,
  Award,
  Edit3
} from 'lucide-react';

const AdminDashboard = ({ onLogout }) => {
  const [activeTab, setActiveTab] = useState('overview');

  const stats = {
    totalCertificates: 1247,
    activeCertificates: 1189,
    pendingCertificates: 58,
    totalReviews: 342,
    averageRating: 4.8,
    totalUsers: 892
  };

  const menuItems = [
    { id: 'overview', label: 'Genel Bakış', icon: Home },
    { id: 'certificates', label: 'Sertifikalar', icon: Award },
    { id: 'reviews', label: 'Müşteri Yorumları', icon: Star },
    { id: 'content', label: 'İçerik Yönetimi', icon: Edit3 },
    { id: 'analytics', label: 'Analitik', icon: BarChart3 },
    { id: 'users', label: 'Kullanıcılar', icon: Users },
    { id: 'settings', label: 'Ayarlar', icon: Settings }
  ];

  const renderOverview = () => (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-neutral-800">Genel Bakış</h2>
      
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white rounded-xl p-6 shadow-sm border border-neutral-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-neutral-600">Toplam Sertifika</p>
              <p className="text-2xl font-bold text-neutral-800">{stats.totalCertificates}</p>
            </div>
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
              <Award className="h-6 w-6 text-primary-600" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-neutral-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-neutral-600">Aktif Sertifika</p>
              <p className="text-2xl font-bold text-green-600">{stats.activeCertificates}</p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <Award className="h-6 w-6 text-green-600" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-neutral-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-neutral-600">Müşteri Yorumları</p>
              <p className="text-2xl font-bold text-neutral-800">{stats.totalReviews}</p>
            </div>
            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
              <Star className="h-6 w-6 text-yellow-600" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm border border-neutral-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-neutral-600">Ortalama Puan</p>
              <p className="text-2xl font-bold text-neutral-800">{stats.averageRating}/5</p>
            </div>
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <BarChart3 className="h-6 w-6 text-blue-600" />
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-neutral-200">
        <h3 className="text-lg font-semibold text-neutral-800 mb-4">Son Aktiviteler</h3>
        <div className="space-y-4">
          <div className="flex items-center space-x-3 p-3 bg-neutral-50 rounded-lg">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <div className="flex-1">
              <p className="text-sm font-medium text-neutral-800">Yeni sertifika oluşturuldu</p>
              <p className="text-xs text-neutral-600">TechCorp GmbH - 2 saat önce</p>
            </div>
          </div>
          <div className="flex items-center space-x-3 p-3 bg-neutral-50 rounded-lg">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <div className="flex-1">
              <p className="text-sm font-medium text-neutral-800">Müşteri yorumu eklendi</p>
              <p className="text-xs text-neutral-600">Maria Schmidt - 4 saat önce</p>
            </div>
          </div>
          <div className="flex items-center space-x-3 p-3 bg-neutral-50 rounded-lg">
            <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
            <div className="flex-1">
              <p className="text-sm font-medium text-neutral-800">Sertifika yenilendi</p>
              <p className="text-xs text-neutral-600">EcoTech Industries - 6 saat önce</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return renderOverview();
      case 'certificates':
        return <div className="text-center py-12"><p>Sertifika yönetimi yakında...</p></div>;
      case 'reviews':
        return <div className="text-center py-12"><p>Müşteri yorumları yakında...</p></div>;
      case 'content':
        return <div className="text-center py-12"><p>İçerik yönetimi yakında...</p></div>;
      default:
        return renderOverview();
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <Award className="h-5 w-5 text-white" />
              </div>
              <h1 className="text-xl font-bold text-neutral-800">CO2 Neutral Admin</h1>
            </div>
            <button
              onClick={onLogout}
              className="flex items-center space-x-2 text-neutral-600 hover:text-neutral-800 transition-colors"
            >
              <LogOut className="h-5 w-5" />
              <span>Çıkış Yap</span>
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex space-x-8">
          {/* Sidebar */}
          <div className="w-64 flex-shrink-0">
            <nav className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors ${
                      activeTab === item.id
                        ? 'bg-primary-500 text-white'
                        : 'text-neutral-600 hover:bg-neutral-100'
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                    <span className="font-medium">{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 